import { TFunction } from '@lyearn/i18n';
import { markdownBreakToParagraphs } from '@lyearn/lygo-blocks';
import { getMarkdownParser, getSchema, Schema } from '@lyearn/lygo-core';
import { meetingEditorExtensions } from '@/lygo/MeetingsNotes';
import { CourseLessonPage } from '@/modules/corporate/modules/course/Extensions/@ly';
import { getSelectionAndPastePlguins } from '@/modules/corporate/modules/course/hooks/useRichEditorProps';

export function getNotesEditorSchema(t: TFunction) {
  const { nodes, marks, plugins, nodePerformanceMap, inputRules, markdownTokens } = getSchema([
    CourseLessonPage,
    ...(meetingEditorExtensions as any),
  ]);
  const { blockquote, ...otherNode } = nodes;
  const editorSchema = new Schema({ marks, nodes: otherNode });

  const markdownParser = getMarkdownParser(editorSchema, markdownTokens, [
    markdownBreakToParagraphs,
  ]);

  const selectionPlugins = getSelectionAndPastePlguins({
    markdownParser,
    schema: editorSchema,
    CustomComponent: undefined,
    t,
  });

  return {
    marks,
    nodes: otherNode,
    schema: editorSchema,
    nodePerformanceMap,
    plugins: [...plugins, ...selectionPlugins],
    inputRules,
  };
}
